export const RULER_HEIGHT_IN_PX = 40;
export const ROW_HEIGHT_IN_PX = 60;
export const ELEMENT_HEIGHT_IN_PX = 80;
export const DEFAULT_ZOOM_LEVEL = 1;
